<script context="module" lang="ts">
	import icoPhone from 'iconoir/icons/phone.svg';
	const placeholderImage = import.meta.env.VITE_DEFAULTIMAGE;
</script>

<script lang="ts">
	export let id = null;
	export let locationImage = placeholderImage;
	export let locationImageFocal = 'center center';
	export let locationName = 'Undefined';
	export let locationDesc = 'Undefined';
	export let locationAddr = 'Undefined';
	export let locationHours = 'Mon - Sat';
	export let locationPhone = '0417503517';
	export let locationPhoneLink = '0417503517';
</script>

<div class="relative rounded-md bg-white p-2 pb-4 drop-shadow-sm md:drop-shadow">
	<div
		style="background: url({locationImage}); background-repeat: no-repeat; background-size: cover; background-position: {locationImageFocal};"
		class="relative min-h-[14rem] rounded"
	>
		<p class="absolute top-0 m-2 w-fit rounded bg-white px-4 py-1 text-neutral-900">
			{locationHours}
		</p>
		<p class="absolute bottom-0 m-2 w-fit rounded bg-white px-4 py-1 text-red-600">
			{locationAddr}
		</p>
	</div>
	<div class="mt-2">
		<div>
			<h2 class="text-lg text-neutral-900 dark:text-neutral-100">{locationName}</h2>
			<p class="text-neutral-800 dark:text-neutral-200">{locationDesc}</p>
		</div>
		<div class="mt-2 flex items-center">
			<img class="mr-2 h-4" src={icoPhone} alt="" />
			<a href="tel:{locationPhoneLink}"
				><p class="text-neutral-900 dark:text-neutral-100">{locationPhone}</p></a
			>
		</div>
	</div>
</div>
